document.addEventListener('DOMContentLoaded', () => {
  const toggleButtons = document.querySelectorAll('[data-gallery-toggle]');
  const closeButtons = document.querySelectorAll('[data-gallery-close]');
  
  function showContent(container) {
    const content = container.querySelector('[data-content]');
    const gallery = container.querySelector('[data-gallery]');
    const mainText = container.querySelector('[data-main-text]');
    
    gallery.classList.add('opacity-0');
    setTimeout(() => {
      gallery.classList.add('invisible');
      content.classList.remove('invisible');
      mainText.classList.remove('opacity-50');
      setTimeout(() => {
        content.classList.remove('opacity-0');
      }, 50);
    }, 300);
  }
  
  function showGallery(container) {
    const content = container.querySelector('[data-content]');
    const gallery = container.querySelector('[data-gallery]');
    const mainText = container.querySelector('[data-main-text]');
    
    content.classList.add('opacity-0');
    setTimeout(() => {
      content.classList.add('invisible');
      gallery.classList.remove('invisible');
      mainText.classList.add('opacity-50');
      setTimeout(() => {
        gallery.classList.remove('opacity-0');
      }, 50);
    }, 300);
  }
  
  toggleButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      const container = button.closest('.col-span-full');
      const gallery = container.querySelector('[data-gallery]');
      
      if (gallery.classList.contains('invisible')) {
        showGallery(container);
      } else {
        showContent(container);
      }
    });
  });
  
  closeButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      const container = button.closest('.col-span-full');
      showContent(container);
    });
  });
});
